import { Box, Button, Stack, Typography, Tabs, Tab, Alert } from '@mui/material';
import ContainerPainel from 'components/container_painel';
import { Loading } from 'components/login';
import { useAuth } from 'contexts/auth/auth_context';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import { ROUTES } from 'routes/constants';
import useComunidadesRuraisTradicionaisStore from 'stores/forms/comunidades_rurais_tradicionais';
import { ViewStep1 } from './steps/step1';
import { ViewStep2 } from './steps/step2';
import { ViewStep3 } from './steps/step3';
import { ViewInformante } from '../visualizar/steps/informante';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const FormularioComunidadesQuilombolasVisualizar: React.FC = () => {
  const { uuid } = useParams();
  const { user } = useAuth();

  const {
    comunidadesRuraisTradicionais,
    loading,
    getComunidadesRuraisTradicionais
  } = useComunidadesRuraisTradicionaisStore();

  const [activeTab, setActiveTab] = useState(0);
  const [hasData, setHasData] = useState(false);

  const usuariosPermitidos = [
    UserPermissionEnum.MUNICIPAL_MANAGER,
    UserPermissionEnum.STATE_MANAGER,
    UserPermissionEnum.ADMIN,
  ];

  const isUsuarioPermitido = usuariosPermitidos.includes(
    user?.permission.name as UserPermissionEnum,
  );

  useEffect(() => {
    if (uuid) {
      getComunidadesRuraisTradicionais(uuid);
    }
  }, [uuid, getComunidadesRuraisTradicionais]);

  useEffect(() => {
    // Verificar se há dados preenchidos
    if (comunidadesRuraisTradicionais && comunidadesRuraisTradicionais.uuid) {
      const hasAnyData = Boolean(
        comunidadesRuraisTradicionais.assentamentos?.length > 0 ||
        comunidadesRuraisTradicionais.comunidades?.length > 0
      );

      setHasData(hasAnyData);
    }
  }, [comunidadesRuraisTradicionais]);



  const renderTabContent = () => {
    if (!hasData) {
      return (
        <Alert severity="info" sx={{ mt: 2 }}>
          Nenhum dado disponível para este município.
        </Alert>
      );
    }

    switch (activeTab) {
      case 0:
        return (
          <>
            <Typography variant='h3' display={comunidadesRuraisTradicionais.assentamentos?.length > 0 ? 'block' : 'none'}>
              Assentamentos
            </Typography>

            {comunidadesRuraisTradicionais.assentamentos.map((assentamento: any, index: number) => {

              return (
                <Box key={index} mb={3}>
                  <ViewStep1 formData={assentamento} />
                  <ViewStep2 formData={assentamento} />
                  <ViewStep3 formData={assentamento} />
                </Box>
              )
            })}

            <Typography variant='h3' display={comunidadesRuraisTradicionais.comunidades?.length > 0 ? 'block' : 'none'}>
              Comunidades Quilombolas
            </Typography>

            {comunidadesRuraisTradicionais.comunidades.map((comunidade: any, index: number) => {
              return (
                <Box key={index} mb={3}>
                  <ViewStep1 formData={comunidade} />
                  <ViewStep2 formData={comunidade} />
                  <ViewStep3 formData={comunidade} />
                </Box>
              )
            })}

          </>

        );
      case 1:
        return <ViewInformante formData={comunidadesRuraisTradicionais} />;
      default:
        return null;
    }
  };

  return (
    <ContainerPainel
      pagina='Visualizar Formulário de Comunidades Rurais e Tradicionais'
      showBackButton={true}
    >
      {isUsuarioPermitido ? (
        <Stack marginX={'4rem'} paddingTop={'2rem'}>
          {loading ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Loading />
            </Box>
          ) : (
            <>

              <TabPanel value={activeTab} index={0}>
                {renderTabContent()}
              </TabPanel>

              {/* <TabPanel value={activeTab} index={1}>
                {renderTabContent()}
              </TabPanel> */}
            </>
          )}
        </Stack>
      ) : (
        <Stack
          sx={{
            marginX: '4rem',
            paddingTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            backgroundColor: '#FFF',
            borderRadius: '1rem',
            padding: '2rem',
            margin: '2rem',
          }}
        >
          <Typography>
            Você não tem permissão para visualizar este formulário
          </Typography>
        </Stack>
      )}
    </ContainerPainel>
  );
};

export default FormularioComunidadesQuilombolasVisualizar;
